import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Hakkimizda } from './pages/Hakkimizda';
import { Iletisim } from './pages/Iletisim';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/hakkimizda" element={<Hakkimizda data-id="element-5" />} data-id="element-4" />
        <Route path="/iletisim" element={<Iletisim data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}